import { render, staticRenderFns } from "./RoomTypesTable.vue?vue&type=template&id=449ca2dc&scoped=true&"
import script from "./RoomTypesTable.vue?vue&type=script&lang=js&"
export * from "./RoomTypesTable.vue?vue&type=script&lang=js&"
import style0 from "./RoomTypesTable.vue?vue&type=style&index=0&id=449ca2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ca2dc",
  null
  
)

export default component.exports